import { serviceHelpers } from '../helpers';

export const userServices = {
    passwordReset,
    register,
    getRequiredConsent,
    logConsent
};

function register(email, domain) {


    console.log('-----ma2===', email, domain)
    const requestOptions = {
        method: 'POST',
        headers: serviceHelpers.getServiceHeaders(false),
        body: JSON.stringify({ email, domain })
    };

    const url = serviceHelpers.getServiceUrl('/auth/local');

    return fetch(url, requestOptions)
    .then(serviceHelpers.handleServiceResponse)
    .catch(serviceHelpers.handleFetchError)
}

function passwordReset(email) {

    const requestOptions = {
        method: 'PATCH',
        headers: serviceHelpers.getServiceHeaders(false),
        body: JSON.stringify({ email })
    };

    const url = serviceHelpers.getServiceUrl('/auth/local');

    return fetch(url, requestOptions)
    .then(serviceHelpers.handleServiceResponse)
    .catch(serviceHelpers.handleFetchError)
}

function getRequiredConsent() {

    const requestOptions = {
        method: 'GET',
        headers: serviceHelpers.getServiceHeaders(true)
    };

    const url = serviceHelpers.getServiceUrl('/user/consent');

    return fetch(url, requestOptions)
    .then(serviceHelpers.handleServiceResponse)
    .catch(serviceHelpers.handleFetchError)
}

function logConsent(consentType) {

    const requestOptions = {
        method: 'POST',
        headers: serviceHelpers.getServiceHeaders(true),
        body: JSON.stringify({ type: consentType })
    };

    const url = serviceHelpers.getServiceUrl('/user/consent');

    return fetch(url, requestOptions)
    .then(serviceHelpers.handleServiceResponse)
    .catch(serviceHelpers.handleFetchError)
}